import { DocumentFolder } from '@quipex/shared/contracts';
import type { ContextFamily, ContextSelection } from '@quipex/shared/utils';

const DOCUMENT_FOLDER_COLOR_PALETTE = [
    'primary',
    'success',
    'warning',
    'info',
    'caution',
    'destructive',
    'urgent',
] as const satisfies readonly ContextFamily[];

export function toFolderColorContext(folder: DocumentFolder): ContextSelection {
    const seed = toEnumKey(DocumentFolder, folder) ?? String(folder);
    let hash = 0;

    for (let i = 0; i < seed.length; i++) {
        hash = Math.trunc((hash << 5) - hash + seed.charCodeAt(i));
    }

    const index = Math.abs(hash) % DOCUMENT_FOLDER_COLOR_PALETTE.length;

    return { family: DOCUMENT_FOLDER_COLOR_PALETTE[index], tone: 'default' };
}

export function toFolderMutedColorContext(
    folder: DocumentFolder
): ContextSelection {
    return { ...toFolderColorContext(folder), tone: 'muted' };
}

function toEnumKey(
    source: Record<string, string | number>,
    value: number
): string | null {
    const entry = Object.entries(source).find(([, currentValue]) => {
        return typeof currentValue === 'number' && currentValue === value;
    });

    return entry?.[0] ?? null;
}
